import { createWebHistory, createRouter } from 'vue-router'
import store from '@/store'
import LoginPage from '@/pages/LoginPage.vue'
import AgendaPage from '@/pages/AgendaPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
// lazy-loaded
const SettingPage = () => import('@/pages/SettingPage.vue')
const ResetPasswordPage = () => import('@/pages/ResetPasswordPage.vue')
const NewPasswordPage = () => import('@/pages/NewPasswordPage.vue')
const ClientPage = () => import('@/pages/ClientPage.vue')
const PaymentValidationPage = () => import('@/pages/PaymentValidationPage.vue')

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: { authRequired: false },
    },
    {
        path: '/',
        name: 'dashboard',
        alias: ['/dashboard'],
        component: DashboardPage,
        meta: { authRequired: true },
    },
    {
        path: '/reset-password',
        name: 'reset_password',
        component: ResetPasswordPage,
        meta: { authRequired: false },
    },
    {
        path: '/new-password',
        name: 'new_password',
        component: NewPasswordPage,
        meta: { authRequired: false },
    },
    {
        path: '/:account/login',
        name: 'login_account',
        component: LoginPage,
        meta: { authRequired: false },
    },
    {
        path: '/:account',
        name: 'agenda',
        component: AgendaPage,
        meta: { authRequired: true },
    },
    {
        path: '/:account/agenda',
        name: 'agenda',
        component: AgendaPage,
        meta: { authRequired: true },
    },
    {
        path: '/:account?/setting/:component?',
        name: 'setting',
        // lazy-loaded
        component: SettingPage,
        meta: { authRequired: true },
    },
    {
        path: '/client',
        name: 'client',
        // lazy-loaded
        component: ClientPage,
        meta: { authRequired: true },
    },
    {
        path: '/payment-validation',
        name: 'payment_validation',
        // lazy-loaded
        component: PaymentValidationPage,
        meta: { authRequired: false },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if(to.params.hasOwnProperty('account')) {
        localStorage.setItem('account_name', to.params.account)
    } else {
        localStorage.removeItem('account_name')
    }
    
    const loggedIn = store.state.profil?.user

    // trying to access a restricted page + not logged in
    // redirect to login page
    if(to.meta.authRequired && !loggedIn) {
        next({ name: 'login' })
    } else {
        next();
    }
});

export default router
